import React, { FC } from 'react';
import { SortItem } from '@components/UIKit/SortItem/SortItem';
import { getToysSortQuery, PageQueries, replaceQuery } from '@specs/navigation';
import { useRouter } from 'next/router';
interface Props {}
export const Sorting: FC<Props> = ({}) => {
  const router = useRouter();
  const {
    toysSort: toysSortQuery
  }: PageQueries = router.query;
  const toysSort = getToysSortQuery(toysSortQuery);
  const sortHandler = async () => {
    const value: PageQueries['toysSort'] = toysSort === 'newest' ? 'oldest' : 'newest';
    await replaceQuery(router, {
      toysSort: value
    });
  };
  return <div className={'_sortingGrid'} data-sentry-component="Sorting" data-sentry-source-file="Sorting.tsx">
            <SortItem text={'sort.newest'} isIncrease={toysSort === 'oldest'} isActive={toysSort === 'newest' || toysSort === 'oldest'} onClick={async () => {
      await sortHandler();
    }} data-sentry-element="SortItem" data-sentry-source-file="Sorting.tsx" />
        </div>;
};